<template>
  <div class="card" v-if="currentPlace">
    <div class="card-body d-flex">
      <div class="my-auto">
        <div class="d-flex">
          <p class="page-title mb-0 my-auto">{{ currentPlace.name }}</p>
          <i
            class="fas fa-circle-notch fa-spin my-auto ml-3"
            v-if="
              updatePlaceRequest.loading ||
              assignAgentRequest.loading ||
              shareToAgentRequest.loading
            "
          ></i>
        </div>
        <p class="badge badge-pill" :class="'badge-' + currentPlace.status">
          {{ placeStatus }}
        </p>
      </div>
      <div class="ml-auto mb-auto d-flex">
        <button
          v-if="canPromote"
          class="btn btn-primary font-weight-semibold my-auto"
          :class="{ 'mr-2': canPromote }"
          @click="emitEvent('promote')"
        >
          <icon
            name="FeatherArrowUpCircle"
            class="mr-2 icon-white"
            size="sm"
          />Promuovi a cliente
        </button>
        <button
          v-if="canNotify"
          class="btn btn-primary font-weight-semibold my-auto"
          :class="{ 'mr-2': canNotify }"
          @click="emitEvent('notify')"
        >
          <icon
            name="FeatherArrowUpCircle"
            class="mr-2 icon-white"
            size="sm"
          />Segnala alla direzione
        </button>

        <button
          v-if="canAssign"
          class="btn btn-primary font-weight-semibold my-auto"
          @click="emitEvent('assign')"
        >
          <icon
            name="AccountOutline"
            class="mr-2 icon-white"
            size="sm"
          />Assegna agente
        </button>
        <button
          v-if="canSchedule"
          class="btn btn-primary font-weight-semibold my-auto"
          @click="emitEvent('schedule')"
        >
          Conferma dati
        </button>
        <button
          v-if="canComplete && !currentUser.isAgent"
          class="btn btn-primary font-weight-semibold my-auto"
          @click="emitEvent('complete')"
        >
          <icon
            name="FeatherCheckCircle"
            class="mr-2 icon-white"
            size="sm"
          />Completa
        </button>
        <button
          v-if="canCandidate && !currentUser.isAgent"
          @click="emitEvent('candidate')"
          class="btn btn-outline-primary font-weight-semibold"
        >
          <icon
            name="FeatherArrowUpCircle"
            class="mr-2 icon-primary"
            size="sm"
          />Invia alla direzione
        </button>

        <button
          v-if="canReject"
          @click="emitEvent('reject')"
          class="btn btn-outline-primary font-weight-semibold mr-2"
        >
          Rifiuta cliente
        </button>
        <button
          v-if="canAccept"
          @click="emitEvent('accept')"
          class="btn btn-primary font-weight-semibold"
        >
          Accetta cliente
        </button>

        <div
          class="dropdown ml-2"
          v-click-outside="onOutsideClick"
          v-if="canReassign || canDelete || canDiscard || canDownload"
        >
          <a
            @click="dropdownOpen = !dropdownOpen"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <button
              class="btn btn-white border"
              :class="[dropdownOpen ? 'border-primary' : 'border-muted']"
            >
              <icon
                name="dots"
                :class="[dropdownOpen ? 'icon-primary' : 'icon-muted']"
              />
            </button>
          </a>
          <div
            class="dropdown-menu dropdown-menu-right px-0 pb-0 pt-0"
            :class="{ show: dropdownOpen }"
            aria-labelledby="navbarDropdown"
          >
            <p
              class="border-bottom py-3 px-2 clickable mb-0"
              v-if="canReassign"
              @click="emitEvent('reassign')"
            >
              <icon name="AccountOutline" class="mr-3" size="sm" />Ri-assegna
              agente
            </p>
            <p
              class="border-bottom py-3 px-2 clickable mb-0"
              v-if="canDiscard"
              @click="emitEvent('discard')"
            >
              <icon name="Exit" class="mr-3" size="sm" />Abbandona contatto
            </p>
            <p
              class="border-bottom py-3 px-2 clickable mb-0"
              v-if="canDownload"
              @click="download"
            >
              <icon name="Download" class="mr-3" size="sm" />Scarica report
            </p>
            <p
              class="border-bottom py-3 px-2 clickable mb-0"
              v-if="canDownloadContractPreview"
              @click="getContractPdfPreview"
            >
              <icon name="Download" class="mr-3" size="sm" />Proposta contratto
            </p>
            <p
              class="border-bottom py-3 px-2 clickable mb-0"
              v-if="canDelete"
              @click="emitEvent('delete')"
            >
              <icon name="Trash" class="mr-3" size="sm" />Elimina contatto
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex card-body border-top">
      <div class="d-flex flex-column flex-lg-row w-100">
        <p
          class="my-lg-auto text-muted mr-4"
          v-if="currentPlace.address.fullAddress"
        >
          <icon class="icon-muted" name="Pin" size="sm" />
          <a
            :href="mapsAction"
            class="ml-2 clickable text-muted"
            target="_blank"
            >{{ currentPlace.address.fullAddress }}</a
          >
        </p>
        <p class="my-lg-auto text-muted" v-if="currentPlace.company.phone">
          <icon class="icon-muted" name="Phone" size="sm" />
          <a class="ml-2 clickable text-muted" :href="callAction">{{
            currentPlace.company.phone
          }}</a>
        </p>
        <div class="d-flex ml-lg-auto">
          <p
            v-if="currentPlace.agent.id && !ownsPlace"
            class="my-lg-auto text-muted"
          >
            <icon name="AccountOutline" class="icon-muted" size="sm" />
            <span class="ml-2">{{ currentPlace.agent.fullname() }}</span>
          </p>
          <p
            class="text-primary my-lg-auto ml-lg-auto mt-auto font-weight-semibold clickable"
            @click="emitEvent('share')"
            v-if="canShare"
          >
            <icon class="icon-primary" name="Share" />
            <span>Condividi contatto</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import axios from "axios";
import Icon from "components/Icon.vue";
import ClickOutside from "directives/ClickOutside";
import PlaceAuthorizationMixin from "mixins/PlaceAuthorizationMixin";
import PlacesMixin from "mixins/http/PlacesMixin";
import { Place, User } from "models";
import { RequestData } from "store/types";
import { RegisterHttp } from "utils/Decorators";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { downlodadFileFromArrayBuffer } from "models/DownloadHelper";

@Component({
  components: {
    Icon,
  },
  directives: {
    ClickOutside,
  },
})
export default class PlaceEdit extends Mixins(
  PlaceAuthorizationMixin,
  PlacesMixin,
) {
  @Getter currentUser?: User;
  @Getter currentPlace?: Place;

  dropdownOpen: boolean = false;

  @Prop() disabled?: boolean;

  static readonly updatePlaceTag = "update_place";
  @RegisterHttp(PlaceEdit.updatePlaceTag) updatePlaceRequest: RequestData;

  static readonly assignAgentTag = "assign_agent";
  @RegisterHttp(PlaceEdit.assignAgentTag) assignAgentRequest: RequestData;

  static readonly downloadReportTag = "download_report";
  @RegisterHttp(PlaceEdit.downloadReportTag) downloadReportRequest: RequestData;

  static readonly shareToAgentTag = "share_to_agent";
  @RegisterHttp(PlaceEdit.shareToAgentTag) shareToAgentRequest: RequestData;

  @Action("http/register") registerCall;
  static readonly downloadContractPreviewTag = "download_contract_preview";

  emitEvent(name: string) {
    this.$emit(name);
  }

  onOutsideClick() {
    if (this.dropdownOpen) this.dropdownOpen = false;
  }

  get downloadContractPreviewTag() {
    return `${PlaceEdit.downloadContractPreviewTag}_${this.currentPlace?.id}`;
  }

  get callAction() {
    return `tel:${this.currentPlace?.company?.phone}`;
  }

  get mapsAction() {
    return `http://maps.google.com/?q=${this.currentPlace.address.fullAddress}`;
  }

  get ownsPlace() {
    return this.currentPlace?.agent?.id === this.currentUser.id;
  }

  get canDiscard() {
    return this.canDiscardPlace(this.currentUser, this.currentPlace);
  }

  get canCandidate() {
    return this.canCandidatePlace(this.currentUser, this.currentPlace);
  }

  get canComplete() {
    return this.canCompletePlace(this.currentUser, this.currentPlace);
  }

  get updatePlaceTag() {
    return PlaceEdit.updatePlaceTag;
  }

  get canDownload() {
    return this.canDownloadPlaceReport(this.currentUser, this.currentPlace);
  }

  get canDownloadContractPreview() {
    return (
      this.currentPlace?.version === 2 &&
      this.currentUser?.isManager &&
      (!this.currentPlace?.isDraft ||
        !this.currentPlace?.isPending ||
        !this.currentPlace?.isRejected ||
        !this.currentPlace?.isLead)
    );
  }

  openDocument(link) {
    window.open(link, "_blank");
  }

  get canShare() {
    return this.canSharePlace(this.currentUser, this.currentPlace);
  }

  get placeStatus() {
    return Place.getStatusLabel(this.currentPlace.status);
  }

  get canReject() {
    return this.canRejectPlace(this.currentUser, this.currentPlace);
  }

  get canAccept() {
    return this.canAcceptPlace(this.currentUser, this.currentPlace);
  }

  get canDelete() {
    return this.canDeletePlace(this.currentUser, this.currentPlace);
  }

  get canAssign() {
    return this.canAssignPlace(this.currentUser, this.currentPlace);
  }

  get canSchedule() {
    return this.canSchedulePlace(this.currentUser, this.currentPlace);
  }

  download() {
    axios({
      method: "get",
      url: this.$urlFor("download_place_report_api_v1_pdf", {
        id: this.currentPlace.id,
      }),
      responseType: "arraybuffer",
    }).then((response) => {
      let blob = new Blob([response.data], { type: "application/pdf" });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Scheda_Cliente_${this.currentPlace.name}.pdf`;
      link.click();
    });
  }

  getContractPdfPreview() {
    this.registerCall(this.downloadContractPreviewTag);
    const promise = this.downloadContractPreview(
      this.currentPlace?.id,
      this.downloadContractPreviewTag,
    );
    const pdfName = `Proposta di contratto di ${Place.contractTypes.filter((el) => el.id === this.currentPlace?.order?.newContractType)[0]?.name} - ${this.currentPlace.name}`;
    downlodadFileFromArrayBuffer(promise, pdfName);
  }

  get canNotify() {
    return this.canNotifyPlace(this.currentUser, this.currentPlace);
  }

  get canPromote() {
    return this.canPromotePlace(this.currentUser, this.currentPlace);
  }

  get canReassign() {
    return this.canReassignPlace(this.currentUser, this.currentPlace);
  }
}
</script>

<style scoped>
.dropdown-menu {
  width: 245px !important;
  overflow-y: auto;
}
</style>
